import { DashboardSquare01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { KpiBenchmarkCard } from '@/components/features/reports/kpi-benchmark-card';
import { useKpiBenchmarks } from '@/hooks/use-reports';

export const Route = createFileRoute('/_authenticated/reports/benchmarks')({
  component: KpiBenchmarksPage,
});

function KpiBenchmarksPage() {
  const { t } = useTranslation();
  const { data, isLoading } = useKpiBenchmarks();

  const benchmarks = data?.data ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <HugeiconsIcon icon={DashboardSquare01Icon} className="size-6" />
          {t('reports.benchmarks.title', 'KPI Benchmarks')}
        </h1>
        <p className="text-muted-foreground text-sm">
          {t(
            'reports.benchmarks.description',
            'Industry-standard benchmarks for maintenance KPIs — compare your performance against world-class targets',
          )}
        </p>
      </div>

      {isLoading ? (
        <div className="text-center py-8 text-muted-foreground">Loading benchmarks…</div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {benchmarks.map((benchmark) => (
            <KpiBenchmarkCard key={benchmark.metric} benchmark={benchmark} />
          ))}
        </div>
      )}
    </div>
  );
}
